import React from "react";
import { BookOpen } from "lucide-react";

const Homepage = () => {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4">
      <div className="rounded-2xl border border-bookish-purple/10 bg-white shadow-sm p-10 max-w-md">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-bookish-purple/5">
          <BookOpen className="h-7 w-7 text-bookish-purple/40" />
        </div>
        <h1 className="text-3xl font-serif font-bold text-bookish-purple mb-2">
          The Bookish Circle
        </h1>
        <p className="text-sm text-bookish-purple/60 leading-relaxed">
          Where readers discover independent authors. Coming soon.
        </p>
      </div>
    </div>
  );
};

export default Homepage;
